import { Component, OnInit, ViewChild } from '@angular/core';
import {
  ClientDTO,
  Currency,
  DateRangeParameterDTO,
  ParkerTurnoverReportParameterDTO,
  ParkerTurnoverReportSummaryDTO,
} from '../../../../../base/models/models.swagger.generated';
import { StringHelper } from '../../../../../base/shared/string-helper';
import { GridConstantsFactory } from '../../../../../base/shared/syncfusion/grid-constants-factory';
import { ClientService } from '../../../../../base/services/client/client.service';
import { UntypedFormBuilder } from '@angular/forms';
import { ParkerTurnoverReportService } from '../parker-turnover-report.service';
import { SaveOptions } from '../../../reports-footer/save-options';
import { savedReportsRoute } from '../../../../../core/routing/route-names';
import { Router } from '@angular/router';
import { GridComponent, GridModule } from '@syncfusion/ej2-angular-grids';
import { DataManager } from '@syncfusion/ej2-data';
import { AvpCustomAdaptor } from '../../../../../base/shared/syncfusion/avp-custom-adaptor';
import { SpinnerService } from '../../../../../base/spinner/spinner.service';
import { ReportsFooterComponent } from '../../../reports-footer/reports-footer.component';
import { DateTime } from 'luxon';
import { TranslateModule } from '@ngx-translate/core';
import { DecimalPipe } from '@angular/common';
import { ParkerTurnoverFormComponent } from '../parker-turnover-form/parker-turnover-form.component';
import { TitleBarComponent } from '../../../../../base/shared/title-bar/title-bar.component';

@Component({
    selector: 'app-parker-turnover-report',
    templateUrl: './parker-turnover-report.component.html',
    styleUrls: ['./parker-turnover-report.component.scss'],
    imports: [
        TitleBarComponent,
        ParkerTurnoverFormComponent,
        GridModule,
        ReportsFooterComponent,
        DecimalPipe,
        TranslateModule,
    ]
})
export class ParkerTurnoverReportComponent implements OnInit {

  @ViewChild('grid') public grid: GridComponent;
  @ViewChild(ReportsFooterComponent) public footer: ReportsFooterComponent;

  public get selectedClient(): ClientDTO {
    return this.clientService.selectedClient;
  }

  public Currency = Currency;
  public data: DataManager;
  public summaryData: ParkerTurnoverReportSummaryDTO;
  public filterForm = this.fb.group({
    startDate: [DateTime.now().startOf('month').toJSDate()],
    endDate: [DateTime.now().endOf('month').toJSDate()],
    zoneId: [null],
    parkerId: [null],
  });

  public pageSettings = GridConstantsFactory.createStandardPageSettings();
  public get totalAmount(): number {
    return this.parkTurnoverReportService.totalAmount;
  };

  constructor(public clientService: ClientService,
              private fb: UntypedFormBuilder,
              private router: Router,
              private spinnerService: SpinnerService,
              private parkTurnoverReportService: ParkerTurnoverReportService) {
  }

  public ngOnInit(): void {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.parkTurnoverReportService, this.spinnerService),
    });
    //Initially get all
    if (this.selectedClient) {
      this.searchReports();
    }
  }

  public searchReports(): void {
    if (this.filterForm.get('startDate').value && this.filterForm.get('endDate').value) {
      const parkerTurnoverReportParameterDTO = this.createReportParametersFromFilters();
      this.parkTurnoverReportService.searchParameters = parkerTurnoverReportParameterDTO;
      try {
        this.grid?.refresh();
      } catch (e) {
        // Ignore error when grid is in transition state
      }
      this.summaryData = null;
      this.parkTurnoverReportService.getReportSummary(parkerTurnoverReportParameterDTO)
        .subscribe(summary => {
          this.summaryData = summary;
          this.summaryData.totalAmounts.sort((a, b) => a.currency - b.currency);
        });
    }
  }

  public saveReport(saveOptions: SaveOptions): void {
    this.spinnerService.show();
    const parkerTurnoverReportParameterDTO = this.createReportParametersFromFilters();
    this.parkTurnoverReportService.exportReport(parkerTurnoverReportParameterDTO, saveOptions)
      .subscribe(savedReportFileDTO => {
        this.spinnerService.hide();
        if (saveOptions.saveReport) {
          this.router.navigate([savedReportsRoute]);
        } else {
          this.footer.downloadFile(savedReportFileDTO);
        }
      });
  }

  public formatCurrency(type: Currency): string {
    return 'i18n.shared.currencies.' + Currency[type];
  }

  public formatTime(minutes: number): string {
    return StringHelper.transformToTimeRepresentation(minutes);
  }

  private createReportParametersFromFilters(): ParkerTurnoverReportParameterDTO {
    return new ParkerTurnoverReportParameterDTO({
      dateRange: new DateRangeParameterDTO({
        startDate: DateTime.fromJSDate(this.filterForm.get('startDate').value).startOf('day').toFormat('yyyy-MM-dd'),
        endDate: DateTime.fromJSDate(this.filterForm.get('endDate').value).startOf('day').toFormat('yyyy-MM-dd'),
      }),
      zoneId: this.filterForm.get('zoneId').value,
      parkerIds: this.filterForm.get('parkerId').value,
    });
  }
}
